import getClient from 'utilities/startplusGraphql';
import { Mutations } from 'apollo';

const removeMyFile = async fileId => {
  const startPlusClient = await getClient();
  return startPlusClient.mutate({
    mutation: Mutations.removeMyFile,
    variables: { id: fileId },
  });
};

export default removeMyFile;
